<!--90 re-->



<div class="dx-field">
  <div class="dx-field-label w-50">{{ 'Aus Kategorien entfernen' | translate }}</div>
  <dx-switch [(value)]="removeFromCategories"></dx-switch>
</div>

<div class="dx-field">
  <div class="dx-field-label w-50">{{ 'Aus Produkten entfernen' | translate }}</div>
  <dx-switch [(value)]="removeFromProduct"></dx-switch>
</div>
